import React, { useRef } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import PopupNew from 'components/common/Popup/PopupNew';

import { REQ_ERROR, VALID_ERROR } from 'constants/Constants';

import FieldLongTitlePopup from './FieldLongTitlePopup';

const InputWrapper = (props) => {
    const popupRef = useRef(null);

    const className =
        'field__block' +
        (props.cssTitleClass ? ' ' + props.cssTitleClass : '') +
        (props.isFilled ? ' field__filled' : '') +
        (props.isError ? ' field__error color-red' : '');
    const errorMessage = props.isEmptyValue ? props.reqError : props.validError;

    //TODO rewrite readOnly state
    return (
        <>
            <div
                className={
                    (props.hideBorder ? '' : 'field__bg') +
                    (props.wrapperClassName ? ' ' + props.wrapperClassName : '') +
                    (props.isReadOnly ? ' disabled_block opacity_4 js_border_white_off' : '')
                }
                ref={props.forwardedRef}
            >
                <label htmlFor={props.name} className={className} onClick={(e) => props.setFocus(e)}>
                    {props.children && props.children[0]}
                    <span className="field__label">
                        <span className={props.isLanding ? 'inside' : ''}>{props.labelText}</span>
                    </span>
                    {props.childrenInLabel &&
                        props.children &&
                        props.children.map((children, index) => {
                            if (index !== 0) {
                                return children;
                            }
                        })}
                </label>
                {!props.childrenInLabel &&
                    props.children &&
                    props.children.map((children, index) => {
                        if (index !== 0) {
                            return children;
                        }
                    })}
            </div>
            {props.comment && !props.isError && (
                <div className="field__info_message axis-line flex-wrapper">
                    <p className="smallcopy color-medium-gray">{props.comment}</p>
                    {props.commentLong && (
                        <a
                            className="disk smart-icon-box show-modal"
                            onClick={() => popupRef.current?.open(<FieldLongTitlePopup info={props.commentLong} popupRef={popupRef} />)}
                        >
                            <ins className="bg-icon-16_info_gray" />
                        </a>
                    )}
                </div>
            )}
            {props.isError && !props.isDetached && (
                <div className="field__error_message error-message-no-margin color-red">{props.errorMessage || errorMessage}</div>
            )}
            <PopupNew ref={popupRef} />
        </>
    );
};
InputWrapper.defaultProps = {
    childrenInLabel: false,
    isDetached: false,
};

InputWrapper.propTypes = {
    errorMessage: PropTypes.string,
    cssTitleClass: PropTypes.string,
    name: PropTypes.string.isRequired,
    isReadOnly: PropTypes.bool,
    labelText: PropTypes.string,
    isFilled: PropTypes.bool,
    isError: PropTypes.bool,
};

const mapStateToProps = (state) => {
    return {
        validError: state.messages.jsMessages[VALID_ERROR],
        reqError: state.messages.jsMessages[REQ_ERROR],
    };
};

export default connect(mapStateToProps)(InputWrapper);
